import { resetPassword } from "aws-amplify/auth";

export const sendResetPasswordLink = async (userId) => {
  try {
    await resetPassword({ username: userId });
    return {};
  } catch (error) {
    console.error("Reset password error:", error);
    if (
      error.name === "UserNotFoundException" ||
      error.message?.includes("email is not verified")
    ) {
      return {
        error:
          "Your email address is not verified. Please verify your email to reset your password.",
      };
    }
    return {
      error:
        error.message ||
        "Failed to send reset password link. Please try again.",
    };
  }
};
